import { StateProps } from '@/models/State';

export const getStateAbbrev = (states: StateProps[] | null, stateId: string | null) => {
  if (states == null || stateId == null) return null;

  const state = states.find((s) => s.id === stateId);
  if (state == null) return null;

  return state.abbrev;
};

export const getStateName = (states: StateProps[] | null, stateId: string | null) => {
  if (states == null || stateId == null) return null;

  const state = states.find((s) => s.id === stateId);
  if (state == null) return null;

  return state.name;
};
